<template>
  <div class="cp-backoffice-store-list-view">
    <div class="cp-backoffice-store-list-view-breadcrumbs-container">
      <Breadcrumbs />

      <b-button
        class="cp-backoffice-store-list-view-create-button"
        type="is-primary"
        outlined
        @click="goToNewStore"
        >{{ $t('backoffice.stores.list.add.button') }}</b-button
      >
    </div>

    <b-table
      :data="stores"
      :loading="loading"
      paginated
      backend-pagination
      icon-pack="fas"
      :total="total"
      :per-page="pageSize"
      @page-change="onPageChange"
    >
      <template v-slot:empty>
        <div class="cp-backoffice-store-list-view-no-data">
          <b-icon
            pack="far"
            size="is-large"
            custom-class="has-text-grey"
            icon="folder-open"
          ></b-icon>
          <br />
          <p class="title is-4 has-text-grey">{{ $t('backoffice.stores.list.no.data') }}</p>
        </div>
      </template>
      <template v-slot:default="props">
        <b-table-column
          width="100"
          :label="$t('backoffice.stores.list.no.column')"
          numeric
          centered
        >
          {{ props.row.no }}
        </b-table-column>

        <b-table-column width="200" :label="$t('backoffice.stores.list.image.column')" centered>
          <img :src="props.row.image" />
        </b-table-column>

        <b-table-column width="400" :label="$t('backoffice.stores.list.title.column')">
          {{ props.row.location_name_localized }}
        </b-table-column>

        <b-table-column :label="$t('backoffice.stores.list.action.column')" centered>
          <b-button
            class="cp-backoffice-store-list-view-edit-button"
            type="is-primary"
            rounded
            @click="goToStoreDetail(props.row.id)"
            >{{ $t('backoffice.stores.list.edit.button') }}</b-button
          >
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/backoffice/Breadcrumbs.vue';
import { getDistributions } from '@/apis/distribution';

export default {
  name: 'StoreListView',
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      stores: [],
      loading: false,
      currPage: 1,
      pageSize: 5,
      total: 0,
    };
  },
  async mounted() {
    await this.fetchData(this.currPage, this.pageSize);
  },
  methods: {
    goToStoreDetail(id) {
      this.$router.push({
        name: 'BackofficeStoreEdit',
        params: {
          id,
        },
      });
    },
    goToNewStore() {
      this.$router.push({
        name: 'BackofficeStoreAdd',
      });
    },
    onPageChange(page) {
      this.page = page;
      this.fetchData(page, this.pageSize);
    },
    async fetchData(page, pageSize) {
      this.loading = true;

      try {
        const { distributions, total } = await getDistributions(page, pageSize);
        this.stores = distributions;
        this.total = total;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cp-backoffice-store-list-view {
  flex-grow: 1;
  padding-left: 30px;
  padding-right: 30px;

  &-no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &-breadcrumbs-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  &-edit-button {
    width: 100px;
  }

  &-delete-button {
    width: 100px;
    margin-left: 10px;
  }
}
</style>
